import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import DefaultSidebar from './Sidebar';
import Footer from './Footer';

function MainLayout() {
    // Drawer mobile : fermé par défaut ; sur desktop (lg+) la sidebar est TOUJOURS visible.
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex min-h-screen flex-col bg-slate-50 text-slate-800">
            <Header onToggleSidebar={() => setSidebarOpen(o => !o)} />
            <div className="flex flex-1">
                <DefaultSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                <main className="min-w-0 flex-1">
                    <Outlet />
                </main>
            </div>
            <Footer />
        </div>
    );
}

export default MainLayout;
